
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cosmetology/tag/[tag]",
      function () {
        return require("private-next-pages/cosmetology/tag/[tag].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cosmetology/tag/[tag]"])
      });
    }
  